<template>
    <router-view/>
</template>
<script>
export default{
  created(){
    // let oldConsole = window.console
    // let newConsole = Object.create(null);
    // ['log'].forEach((method) => {
    //   newConsole[method] = function (...args) {
    //       // 非开发环境直接返回
    //       if (process.env.NODE_ENV !== 'development') {
    //           return
    //       }
    //       oldConsole[method](...args)
    //   }
    // })
    // window.console = newConsole
  }
}
</script>
<style>
/*谷哥滚动条样式*/

  ::-webkit-scrollbar {width:10px;height:10px;position:absolute}
  ::-webkit-scrollbar-thumb {background-color:#5bc0de}
  ::-webkit-scrollbar-track {background-color:#ddd}

/***/
.amap-info-content{
  border-radius:10px;
  box-shadow: 0 3px 14px rgb(0 0 0 / 40%);
}
.amap-info-close{
  right: 5px!important;
}
.amap-overlay-text-container{
  font-size: 12px;
}
</style>
